import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { environment } from 'src/environments/environments';

@Injectable({ providedIn: 'root' })
export class LoginGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(): boolean {
    const user = localStorage.getItem(`${environment.appName}user`);
    // if (user && user !== '') {
    //   // ✅ Already logged in → redirect to dashboard
    //   this.router.navigate(['/dashboard'], { replaceUrl: true });
    //   return false;
    // }
    return true; // Not logged in → allow login
  }
}
